import { gql } from "@apollo/client"

const SEND_INVITATION_MUTATION = gql`
  mutation($input: SendInvitationInput!) {
    sendInvitation(input: $input) { 
      success 
    }  
  }
`

export { SEND_INVITATION_MUTATION }
